import React from 'react'
import styled from 'styled-components'
import { RichText } from '../shared/RichText'

import {
  desktopVw,
  mobileVw,
  desktopBreakpoint,
  colors,
  letterSpacing,
  fonts,
} from '../../styles'

export const Preparations = ({ preparation, title }) => {
  return (
    <Wrapper>
      <Title>{title}</Title>
      <Text>{preparation && <RichText json={preparation} isPreparations />}</Text>
    </Wrapper>
  )
}

const Wrapper = styled.article`
  padding: ${mobileVw(33)} ${mobileVw(16)} ${mobileVw(20)};
  background-color: ${colors.lightGrey};

  @media (min-width: ${desktopBreakpoint}) {
    min-height: ${desktopVw(200)};
    padding: 0 ${desktopVw(95)} ${desktopVw(59)} ${desktopVw(128)};
  }
`

const Title = styled.h2`
  margin: 0 0 ${mobileVw(8)};
  font-family: ${fonts.tivoli};
  font-size: ${mobileVw(20)};
  line-height: 1;
  color: ${colors.mailleGold};
  text-transform: uppercase;
  letter-spacing: ${letterSpacing(100)};

  @media (min-width: ${desktopBreakpoint}) {
    margin: 0 0 ${desktopVw(27)};
    font-size: ${desktopVw(28)};
    line-height: ${desktopVw(24)};
  }
`

const Text = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    display: inline-block;
    margin: ${mobileVw(10)} 0 ${mobileVw(3)};
    font-family: ${fonts.tivoli};
    font-size: ${mobileVw(20)};
    line-height: 1;
    letter-spacing: ${letterSpacing(100)};
  }
  p {
    font-family: ${fonts.mrs};
    font-size: ${mobileVw(16)};
    line-height: ${mobileVw(20)};
    margin: 0 0 ${mobileVw(8)};
    padding-left: 0;
  }

  h3 {
    margin: 0;
    padding-right: ${mobileVw(10)};
    float: left;
  }

  img {
    width: 100%;
    height: auto;
    margin: auto;
  }

  @media (min-width: ${desktopBreakpoint}) {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: ${desktopVw(28)};
      line-height: ${desktopVw(28)};
    }

    h3 {
      display: block;
      padding-right: ${desktopVw(10)};
    }

    p {
      display: block;
      font-size: ${desktopVw(20)};
      line-height: ${desktopVw(24)};
    }

    h3 + p {
      padding-left: ${desktopVw(20)};
    }

    img {
      display: block;
      margin: 0 0 ${desktopVw(31)};
    }
  }
`
